import { SxProps, Theme } from "@mui/material/styles";
import theme from "../../theme";

const styles: SxProps<Theme> = [
  {
    "& .footerLogo": {
      display: "flex",
      alignItems: "center",
      height: 89,
      backgroundColor: theme.palette.primary.main,
      padding: "0 1.25rem",
    },
    "& .footerLogoBesse": {
      padding: "4px",
      background: "white",
      marginLeft: "24px",
    },
    "& .footerLiens": {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      height: 23,
      backgroundColor: theme.palette.common.black,
      padding: 0,
      margin: 0,
      paddingTop: "3px",
    },
    "& .footerLien": {
      listStyle: "none",
      textTransform: "uppercase",
      color: theme.palette.common.white,
      fontSize: 10,
      marginLeft: "10px",
      marginTop: "2px",
    },
  },
];

export default styles;
